import { Dimensions, StyleSheet, Text, View } from "react-native";
import { PaymentIcon } from "react-native-payment-icons";
import Icon from 'react-native-vector-icons/MaterialCommunityIcons'

import * as Colors from '../styles/colors'
import * as Fonts from '../styles/typography'
import GetCardType from "../helpers/creditCard";
import Svg, { Defs, LinearGradient, Rect, Stop } from "react-native-svg";

const { width, height } = Dimensions.get("window");

export default function PaymentForm({ number,
    name,
    expiration, }) {

    const brandType = GetCardType(number.replace(/\s/g, ''))

    return (
        <View>
            <Svg height="100%" width="100%" style={StyleSheet.absoluteFillObject}>
                <Defs>
                    <LinearGradient id="grad" x1="100%" y1="0%" x2="100%" y2="100%">
                        <Stop offset="0" stopColor={Colors.PRIMARY} />
                        <Stop offset="1" stopColor={Colors.BLACK} />
                    </LinearGradient>
                </Defs>
                <Rect width="100%" height="100%" fill="url(#grad)" rx={8}/>
            </Svg>
            <View style={styles.card}>
                <View style={styles.cardBrand}>
                    {brandType ? <PaymentIcon width={50} type={brandType.toLowerCase()} /> : null}
                </View>
                <View style={styles.data}>
                    <Icon name={'integrated-circuit-chip'} size={42} color={Colors.CHIP} />
                    <View style={styles.viewNumber}>
                        <Text style={styles.number}>{number ? number : "0000 0000 0000 0000"}</Text>
                    </View>
                    <View style={styles.viewLabels}>
                        <Text style={styles.label}>{"TITULAR DO CARTÃO"}</Text>
                        <Text style={styles.label}>{"VENCIMENTO"}</Text>
                    </View>
                    <View style={styles.viewNameExpiration}>
                        <Text style={styles.name}>{name ? name : "TREVO EST."}</Text>
                        <Text style={styles.expiration}>{expiration ? expiration : "00/00"}</Text>
                    </View>
                </View>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    card: {
        // backgroundColor: Colors.PRIMARY,
        width: '100%',
        height: 200,
        borderRadius: 10,
        padding: 16,
        overflow: "hidden",
    },
    cardBrand: {
        alignItems: "flex-end",
    },
    data: {
        justifyContent: "flex-end",
        flex: 1,
        margin: 8
    },
    viewNumber: {
        marginVertical: 8
    },
    number: {
        color: Colors.WHITE,
        fontSize: Fonts.FONT_SIZE_16,
        fontWeight: "bold",
        letterSpacing: 2,
    },
    viewLabels: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    label: {
        color: Colors.WHITE,
        fontSize: Fonts.FONT_SIZE_12,
    },
    viewNameExpiration: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    name: {
        color: Colors.WHITE,
        fontSize: Fonts.FONT_SIZE_18,
        fontWeight: "bold",
        letterSpacing: 1,
    },
    expiration: {
        color: Colors.WHITE,
        fontSize: Fonts.FONT_SIZE_18,
        fontWeight: "bold",
        letterSpacing: 1,
    }
})